export const NAV_LINKS = [
  { label: "Difference", href: "#difference" },
  { label: "Process", href: "#process" },
  { label: "Programs", href: "#programs" },
  { label: "Technology", href: "#technology" },
  { label: "Founders", href: "#founders" },
  { label: "Results", href: "#results" },
  { label: "Contact", href: "#contact" },
];

export const FEATURES = [
  {
    num: "01",
    title: "Biomechanical Analysis",
    desc: "Motion capture and force-plate data expose exactly how you move — joint by joint, frame by frame — so we fix root causes, not symptoms.",
    icon: "activity",
  },
  {
    num: "02",
    title: "Data-Driven Programming",
    desc: "Every rep is prescribed. Your plan is built from your numbers and adjusts as they change. No guesswork, no generic templates.",
    icon: "line-chart",
  },
  {
    num: "03",
    title: "Velocity Development",
    desc: "Sequencing, intent, and load management engineered to add real, repeatable mph — without sacrificing your arm's long-term health.",
    icon: "zap",
  },
  {
    num: "04",
    title: "Game-Ready Translation",
    desc: "Bullpen gains are worthless if they don't show up on Friday night. We bridge training output to live, in-game performance.",
    icon: "target",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Assess",
    desc: "A full biomechanical capture and movement screen. We measure your mechanics, sequencing, and current velocity to establish a precise baseline.",
  },
  {
    num: "02",
    title: "Build the Plan",
    desc: "Your data becomes a blueprint. We prescribe a periodized program targeting your specific limiters — mobility, sequencing, strength, or intent.",
  },
  {
    num: "03",
    title: "Track Progress",
    desc: "We re-test on a set cadence. Every adjustment is validated against the numbers, so you always know the plan is working — and why.",
  },
];

export const PROGRAMS = [
  {
    name: "Mechanics Assessment",
    price: "150",
    cadence: "/mo",
    tagline: "Understand how you move.",
    featured: false,
    features: [
      "Full biomechanical motion capture",
      "Force-plate ground-reaction analysis",
      "Written movement report & priorities",
      "Baseline velocity & efficiency metrics",
      "60-minute review session",
    ],
  },
  {
    name: "Pitching Velocity Program",
    price: "250",
    cadence: "/mo",
    tagline: "Add mph you can trust.",
    featured: true,
    features: [
      "Everything in Mechanics Assessment",
      "Individualized velocity programming",
      "Monthly motion-capture re-testing",
      "Arm-care & load management protocol",
      "Direct coach access & plan adjustments",
    ],
  },
  {
    name: "Ongoing Athlete Development",
    price: "350",
    cadence: "/mo",
    tagline: "Compound gains, season over season.",
    featured: false,
    features: [
      "Everything in the Velocity Program",
      "Year-round periodized planning",
      "Strength & recovery integration",
      "In-game performance tracking",
      "Priority scheduling & unlimited retests",
    ],
  },
];

export const STATS = [
  { value: 5.4, suffix: " mph", label: "Avg. velocity gained" },
  { value: 300, suffix: "+", label: "Athletes trained" },
  { value: 94, suffix: "%", label: "Measurable improvement rate" },
  { value: 12, suffix: "wk", label: "Avg. time to first gain" },
];

export const TESTIMONIALS = [
  {
    quote:
      "I'd hit a velocity wall for two years. Fuel Factory found the sequencing leak in my delivery in one session. Four months later I touched 91 for the first time.",
    name: "Tyler M.",
    role: "College RHP — D1 commit",
  },
  {
    quote:
      "As a parent, the data changed everything. We finally saw exactly what my son was working on and why. No more paying for guesswork.",
    name: "Dana R.",
    role: "Parent of HS pitcher",
  },
  {
    quote:
      "The retests kept me honest. Watching the numbers move every month is what kept me bought in. This is how development should work.",
    name: "Marcus B.",
    role: "Junior — Varsity",
  },
];

export const MARQUEE = [
  "RESULTS DRIVEN",
  "PROVEN MECHANICS",
  "VELOCITY GAINS",
  "TRUST THE DATA",
  "OWN THE MOUND",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1619030945899-c4307ae42479?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxiYXNlYmFsbCUyMHBpdGNoZXIlMjBkYXJrJTIwY2luZW1hdGljfGVufDB8fHx8MTc4NDMwMTA0MXww&ixlib=rb-4.1.0&q=85",
  technology:
    "https://images.unsplash.com/photo-1534258936925-c58bed479fcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxhdGhsZXRlJTIwdHJhaW5pbmclMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4NDMwMTA0Mnww&ixlib=rb-4.1.0&q=85",
};
